import { Button, MenuItem } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import LanguageIcon from "@material-ui/icons/Language";
import React from "react";
import getFullLanguageName from "../languageHandling/getFullLanguageName";
import i18n from "../languageHandling/i18n";
import styles from "./LanguageSwitcher.module.scss";

const LanguageSwitcher: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    handleClose();
    window.location.reload();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={styles.switcher}>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <LanguageIcon />
        <p className={styles.language}>{i18n.language}</p>
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        onClose={handleClose}
        open={Boolean(anchorEl)}
      >
        {Object.keys(i18n.services.resourceStore.data).map((lang) => (
          <MenuItem
            key={`lngOption-${lang}`}
            onClick={() => changeLanguage(lang)}
          >
            {getFullLanguageName(lang)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
export default LanguageSwitcher;
